import React from 'react';
import { Mail } from 'lucide-react';
export function PrivacyPolicyContent() {
  return <div className="text-gray-300 space-y-6 leading-relaxed" data-id="element-253">
      <p className="text-lg text-white font-semibold" data-id="element-254">
        Última actualización: Enero 2024
      </p>

      <section data-id="element-255">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-256">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-257">
          En MÉTODO CIERRE 90' recopilamos únicamente la información necesaria
          para procesar tu compra y entregarte el producto digital:
        </p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-258">
          <li data-id="element-259">Nombre y apellido</li>
          <li data-id="element-260">Dirección de correo electrónico</li>
          <li data-id="element-261">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
        </ul>
      </section>

      <section data-id="element-262">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-263">
          2. Uso de la Información
        </h3>
        <p data-id="element-264">Utilizamos tu información para:</p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-265">
          <li data-id="element-266">Procesar y completar tu compra</li>
          <li data-id="element-267">Enviarte el acceso al producto digital adquirido</li>
          <li data-id="element-268">Comunicarnos contigo sobre tu pedido</li>
          <li data-id="element-269">
            Enviarte actualizaciones importantes sobre el producto (solo si lo
            autorizas)
          </li>
        </ul>
      </section>

      <section data-id="element-270">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-271">
          3. Protección de Datos
        </h3>
        <p data-id="element-272">
          Implementamos medidas de seguridad para proteger tu información
          personal. Utilizamos encriptación SSL y trabajamos con procesadores de
          pago certificados que cumplen con los estándares PCI-DSS.
        </p>
      </section>

      <section data-id="element-273">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-274">
          4. Compartir Información
        </h3>
        <p data-id="element-275">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cuando
          la ley lo requiera.
        </p>
      </section>

      <section data-id="element-276">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-277">5. Tus Derechos</h3>
        <p data-id="element-278">Tienes derecho a:</p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-279">
          <li data-id="element-280">Acceder a tu información personal</li>
          <li data-id="element-281">Solicitar la corrección de datos incorrectos</li>
          <li data-id="element-282">Solicitar la eliminación de tus datos</li>
          <li data-id="element-283">Retirar tu consentimiento para comunicaciones de marketing</li>
        </ul>
      </section>

      <section data-id="element-284">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-285">6. Cookies</h3>
        <p data-id="element-286">
          Utilizamos cookies esenciales para el funcionamiento del sitio web y
          para mejorar tu experiencia de usuario. Puedes configurar tu navegador
          para rechazar cookies, aunque esto puede afectar algunas
          funcionalidades.
        </p>
      </section>

      <section data-id="element-287">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-288">7. Contacto</h3>
        <p data-id="element-289">
          Si tienes preguntas sobre nuestra política de privacidad, contáctanos
          en:
        </p>
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-gold-500 hover:underline inline-flex items-center gap-2 mt-2" data-id="element-290">
          <Mail className="w-4 h-4" data-id="element-291" />
          contactomikioscodigital@gmail.com
        </a>
      </section>
    </div>;
}
export function TermsAndConditionsContent() {
  return <div className="text-gray-300 space-y-6 leading-relaxed" data-id="element-292">
      <p className="text-lg text-white font-semibold" data-id="element-293">
        Última actualización: Enero 2024
      </p>

      <section data-id="element-294">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-295">
          1. Aceptación de Términos
        </h3>
        <p data-id="element-296">
          Al comprar y utilizar MÉTODO CIERRE 90', aceptas estos términos y
          condiciones. Si no estás de acuerdo, por favor no realices la compra.
        </p>
      </section>

      <section data-id="element-297">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-298">
          2. Descripción del Producto
        </h3>
        <p data-id="element-299">MÉTODO CIERRE 90' es un producto digital (ebook) que incluye:</p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-300">
          <li data-id="element-301">Ebook principal "Adiós al Caos por el Estrés Laboral"</li>
          <li data-id="element-302">6 ebooks complementarios (bonos)</li>
          <li data-id="element-303">Plantillas y recursos descargables</li>
        </ul>
        <p className="mt-3" data-id="element-304">
          El producto es de naturaleza digital y se entrega mediante descarga
          inmediata tras la confirmación del pago.
        </p>
      </section>

      <section data-id="element-305">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-306">3. Precio y Pago</h3>
        <p data-id="element-307">
          El precio del producto se muestra claramente en el sitio web.
          Aceptamos pagos mediante tarjeta de crédito/débito y otros métodos
          procesados por nuestro proveedor de pagos seguro.
        </p>
      </section>

      <section data-id="element-308">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-309">
          4. Política de Reembolso
        </h3>
        <p data-id="element-310">
          Ofrecemos una garantía de satisfacción de 30 días. Si no estás
          satisfecho con el producto, puedes solicitar un reembolso completo
          dentro de los 30 días posteriores a la compra contactándonos a:
        </p>
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-gold-500 hover:underline inline-flex items-center gap-2 mt-2" data-id="element-311">
          <Mail className="w-4 h-4" data-id="element-312" />
          contactomikioscodigital@gmail.com
        </a>
      </section>

      <section data-id="element-313">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-314">
          5. Uso del Producto
        </h3>
        <p data-id="element-315">
          Al adquirir MÉTODO CIERRE 90', obtienes una licencia personal e
          intransferible para:
        </p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-316">
          <li data-id="element-317">Descargar y utilizar el contenido para tu uso personal</li>
          <li data-id="element-318">Imprimir copias para tu uso personal</li>
        </ul>
        <p className="mt-3 font-semibold text-white" data-id="element-319">NO está permitido:</p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-320">
          <li data-id="element-321">Compartir, revender o distribuir el contenido</li>
          <li data-id="element-322">Reproducir el contenido públicamente sin autorización</li>
          <li data-id="element-323">Modificar o crear obras derivadas sin permiso</li>
        </ul>
      </section>

      <section data-id="element-324">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-325">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-326">
          Todo el contenido de MÉTODO CIERRE 90' está protegido por derechos de
          autor. La propiedad intelectual pertenece a los creadores del método.
        </p>
      </section>

      <section data-id="element-327">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-328">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-329">
          MÉTODO CIERRE 90' es una herramienta de productividad y organización.
          No sustituye el asesoramiento profesional en salud mental, médico o
          psicológico. Si experimentas estrés crónico severo, consulta con un
          profesional de salud mental.
        </p>
      </section>

      <section data-id="element-330">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-331">8. Modificaciones</h3>
        <p data-id="element-332">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios se publicarán en esta página con la fecha de
          actualización correspondiente.
        </p>
      </section>

      <section data-id="element-333">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-334">9. Contacto</h3>
        <p data-id="element-335">Para cualquier consulta sobre estos términos y condiciones:</p>
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-gold-500 hover:underline inline-flex items-center gap-2 mt-2" data-id="element-336">
          <Mail className="w-4 h-4" data-id="element-337" />
          contactomikioscodigital@gmail.com
        </a>
      </section>
    </div>;
}
export function ContactContent() {
  return <div className="text-gray-300 space-y-8 leading-relaxed" data-id="element-338">
      <section className="text-center" data-id="element-339">
        <h3 className="text-2xl font-bold text-white mb-4" data-id="element-340">
          ¿Necesitas ayuda?
        </h3>
        <p className="text-lg mb-6" data-id="element-341">
          Estamos aquí para ayudarte con cualquier pregunta sobre MÉTODO CIERRE
          90'
        </p>
      </section>

      <section className="bg-white/5 border border-gold-500/20 rounded-xl p-8 text-center" data-id="element-342">
        <Mail className="w-12 h-12 text-gold-500 mx-auto mb-4" data-id="element-343" />
        <h4 className="text-xl font-bold text-white mb-3" data-id="element-344">Email de Soporte</h4>
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-gold-500 hover:text-gold-400 text-lg font-medium transition-colors" data-id="element-345">
          contactomikioscodigital@gmail.com
        </a>
        <p className="text-gray-400 text-sm mt-4" data-id="element-346">
          Tiempo de respuesta: 24-48 horas hábiles
        </p>
      </section>

      <section data-id="element-347">
        <h4 className="text-xl font-bold text-white mb-4" data-id="element-348">
          Preguntas Frecuentes
        </h4>
        <div className="space-y-4" data-id="element-349">
          <div className="bg-white/5 rounded-lg p-4" data-id="element-350">
            <p className="font-semibold text-white mb-2" data-id="element-351">
              ¿Cómo accedo al producto después de la compra?
            </p>
            <p className="text-sm" data-id="element-352">
              Recibirás un email inmediatamente después de confirmar tu pago con
              el enlace de descarga y acceso a todos los materiales.
            </p>
          </div>

          <div className="bg-white/5 rounded-lg p-4" data-id="element-353">
            <p className="font-semibold text-white mb-2" data-id="element-354">
              ¿Puedo solicitar un reembolso?
            </p>
            <p className="text-sm" data-id="element-355">
              Sí, ofrecemos garantía de 30 días. Si no estás satisfecho,
              contáctanos y procesaremos tu reembolso.
            </p>
          </div>

          <div className="bg-white/5 rounded-lg p-4" data-id="element-356">
            <p className="font-semibold text-white mb-2" data-id="element-357">
              ¿El contenido se actualiza?
            </p>
            <p className="text-sm" data-id="element-358">
              Sí, recibirás acceso a todas las actualizaciones futuras del
              método sin costo adicional.
            </p>
          </div>
        </div>
      </section>

      <section className="border-t border-white/10 pt-6" data-id="element-359">
        <p className="text-center text-gray-400" data-id="element-360">
          Para consultas sobre pedidos, reembolsos, acceso al producto o
          cualquier otra pregunta, no dudes en escribirnos. Estamos
          comprometidos a brindarte la mejor experiencia posible.
        </p>
      </section>
    </div>;
}